import React from 'react'
import { Heat as HeatType } from '@/types'
import { useGameplayContext } from '@/contexts/gameplayContext'
import { formatUnderscoreCase } from '@/utils'

interface HeatProps {
  heat: HeatType
  roundKey: string
  heatIndex: number
}

export const Heat: React.FC<HeatProps> = ({ heat, roundKey, heatIndex }) => {
  const { gameData } = useGameplayContext()

  return (
    <div className="w-[220px]">
      {/* Header - blue for completed heats, grey for incomplete */}
      <div
        className={`px-3 py-2 rounded-t-lg text-sm font-medium
        ${heat.results ? 'bg-blue-600/50' : 'bg-gray-700/50'}`}
      >
        {formatUnderscoreCase(roundKey)} H{heatIndex + 1}
      </div>

      {/* Table */}
      <div className="bg-white/10 rounded-b-lg overflow-hidden">
        <table className="w-full">
          <tbody>
            {heat.results
              ? // Results view
                heat.results
                  .sort((a, b) => a.position - b.position)
                  .map((result) => (
                    <tr
                      key={result.competitorName}
                      className={`text-sm border-t border-white/10 
                        ${result.competitorName === gameData.username ? 'bg-blue-500/50' : ''}`}
                    >
                      <td className="px-2 py-2 w-8">{result.position}</td>
                      <td className="px-2 py-2">
                        <div className="truncate max-w-[140px]">
                          {result.competitorName === gameData.username ? 'You' : result.competitorName}
                        </div>
                      </td>
                      <td className="px-2 py-2 w-16 text-right">{result.score.toFixed(1)}</td>
                    </tr>
                  ))
              : // Pre-heat view
                heat.competitors.map((competitor) => (
                  <tr
                    key={competitor}
                    className={`text-sm border-t border-white/10 
                      ${competitor === gameData.username ? 'bg-blue-500/50' : ''}`}
                  >
                    <td className="px-2 py-2">
                      <div className="truncate max-w-[180px]">
                        {competitor === gameData.username ? 'You' : competitor}
                      </div>
                    </td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
